import tangramDesignTokens, { colorGray100, colorGray90, colorGray80, colorGray70, colorGray60, colorGray50, colorGray40, colorGray30, colorGray20, colorGray10, colorWhite, colorRed50, colorRed40, colorRed30, colorRed20, colorRed10, colorYellow50, colorYellow40, colorYellow30, colorYellow20, colorYellow10, colorGreen50, colorGreen40, colorGreen30, colorGreen20, colorGreen10, colorPurple50, colorPurple40, colorPurple30, colorPurple20, colorPurple10, colorMidnightblue1, colorMidnightblue2, colorMidnightblue3, colorMidnightblue4, colorOrchid1, colorOrchid2, colorOrchid3, colorOrchid4, colorDeepskyblue1, colorDeepskyblue2, colorDeepskyblue3, colorDeepskyblue4, colorDeeppurple1, colorDeeppurple2, colorDeeppurple3, colorDeeppurple4, colorDeeppink1, colorDeeppink2, colorDeeppink3, colorDeeppink4, colorVioletred1, colorVioletred2, colorVioletred3, colorVioletred4, colorTan1, colorTan2, colorTan3, colorTan4, colorSienna1, colorSienna2, colorSienna3, colorSienna4, colorGoldenorange1, colorGoldenorange2, colorGoldenorange3, colorGoldenorange4, colorOlive1, colorOlive2, colorOlive3, colorOlive4, colorSeagreen1, colorSeagreen2, colorSeagreen3, colorSeagreen4 } from '@resultadosdigitais/tangram-design-tokens';
const {
  primarySurfaceHighEmphasis,
  primarySurfaceHover,
  primarySurfaceLowEmphasis,
  neutralSurface,
  neutralSurfaceHighEmphasis,
  neutralSurfaceLowEmphasis,
  neutralSurfaceHover,
  neutralSurfaceDisabled,
  neutralSurfaceInverse,
  neutralSurfaceInverseHover,
  dangerSurfaceHighEmphasis,
  dangerSurfaceHover,
  dangerSurfaceLowEmphasis,
  successSurfaceHighEmphasis,
  successSurfaceHover,
  successSurfaceLowEmphasis,
  warningSurfaceHighEmphasis,
  warningSurfaceHover,
  warningSurfaceLowEmphasis,
  highlightSurfaceHighEmphasis,
  highlightSurfaceHover,
  highlightSurfaceLowEmphasis
} = tangramDesignTokens('lina');
export const colorsPallet = {
  COLOR_GRAY_100: colorGray100,
  COLOR_GRAY_90: colorGray90,
  COLOR_GRAY_80: colorGray80,
  COLOR_GRAY_70: colorGray70,
  COLOR_GRAY_60: colorGray60,
  COLOR_GRAY_50: colorGray50,
  COLOR_GRAY_40: colorGray40,
  COLOR_GRAY_30: colorGray30,
  COLOR_GRAY_20: colorGray20,
  COLOR_GRAY_10: colorGray10,
  COLOR_WHITE: colorWhite,
  COLOR_RED_50: colorRed50,
  COLOR_RED_40: colorRed40,
  COLOR_RED_30: colorRed30,
  COLOR_RED_20: colorRed20,
  COLOR_RED_10: colorRed10,
  COLOR_YELLOW_50: colorYellow50,
  COLOR_YELLOW_40: colorYellow40,
  COLOR_YELLOW_30: colorYellow30,
  COLOR_YELLOW_20: colorYellow20,
  COLOR_YELLOW_10: colorYellow10,
  COLOR_GREEN_50: colorGreen50,
  COLOR_GREEN_40: colorGreen40,
  COLOR_GREEN_30: colorGreen30,
  COLOR_GREEN_20: colorGreen20,
  COLOR_GREEN_10: colorGreen10,
  COLOR_PURPLE_50: colorPurple50,
  COLOR_PURPLE_40: colorPurple40,
  COLOR_PURPLE_30: colorPurple30,
  COLOR_PURPLE_20: colorPurple20,
  COLOR_PURPLE_10: colorPurple10,
  COLOR_MIDNIGHTBLUE_1: colorMidnightblue1,
  COLOR_MIDNIGHTBLUE_2: colorMidnightblue2,
  COLOR_MIDNIGHTBLUE_3: colorMidnightblue3,
  COLOR_MIDNIGHTBLUE_4: colorMidnightblue4,
  COLOR_ORCHID_1: colorOrchid1,
  COLOR_ORCHID_2: colorOrchid2,
  COLOR_ORCHID_3: colorOrchid3,
  COLOR_ORCHID_4: colorOrchid4,
  COLOR_DEEPSKYBLUE_1: colorDeepskyblue1,
  COLOR_DEEPSKYBLUE_2: colorDeepskyblue2,
  COLOR_DEEPSKYBLUE_3: colorDeepskyblue3,
  COLOR_DEEPSKYBLUE_4: colorDeepskyblue4,
  COLOR_DEEPPURPLE_1: colorDeeppurple1,
  COLOR_DEEPPURPLE_2: colorDeeppurple2,
  COLOR_DEEPPURPLE_3: colorDeeppurple3,
  COLOR_DEEPPURPLE_4: colorDeeppurple4,
  COLOR_DEEPPINK_1: colorDeeppink1,
  COLOR_DEEPPINK_2: colorDeeppink2,
  COLOR_DEEPPINK_3: colorDeeppink3,
  COLOR_DEEPPINK_4: colorDeeppink4,
  COLOR_VIOLETRED_1: colorVioletred1,
  COLOR_VIOLETRED_2: colorVioletred2,
  COLOR_VIOLETRED_3: colorVioletred3,
  COLOR_VIOLETRED_4: colorVioletred4,
  COLOR_TAN_1: colorTan1,
  COLOR_TAN_2: colorTan2,
  COLOR_TAN_3: colorTan3,
  COLOR_TAN_4: colorTan4,
  COLOR_SIENNA_1: colorSienna1,
  COLOR_SIENNA_2: colorSienna2,
  COLOR_SIENNA_3: colorSienna3,
  COLOR_SIENNA_4: colorSienna4,
  COLOR_GOLDENORANGE_1: colorGoldenorange1,
  COLOR_GOLDENORANGE_2: colorGoldenorange2,
  COLOR_GOLDENORANGE_3: colorGoldenorange3,
  COLOR_GOLDENORANGE_4: colorGoldenorange4,
  COLOR_OLIVE_1: colorOlive1,
  COLOR_OLIVE_2: colorOlive2,
  COLOR_OLIVE_3: colorOlive3,
  COLOR_OLIVE_4: colorOlive4,
  COLOR_SEAGREEN_1: colorSeagreen1,
  COLOR_SEAGREEN_2: colorSeagreen2,
  COLOR_SEAGREEN_3: colorSeagreen3,
  COLOR_SEAGREEN_4: colorSeagreen4,
  primarySurfaceHighEmphasis,
  primarySurfaceHover,
  primarySurfaceLowEmphasis,
  neutralSurface,
  neutralSurfaceHighEmphasis,
  neutralSurfaceLowEmphasis,
  neutralSurfaceHover,
  neutralSurfaceDisabled,
  neutralSurfaceInverse,
  neutralSurfaceInverseHover,
  dangerSurfaceHighEmphasis,
  dangerSurfaceHover,
  dangerSurfaceLowEmphasis,
  successSurfaceHighEmphasis,
  successSurfaceHover,
  successSurfaceLowEmphasis,
  warningSurfaceHighEmphasis,
  warningSurfaceHover,
  warningSurfaceLowEmphasis,
  highlightSurfaceHighEmphasis,
  highlightSurfaceHover,
  highlightSurfaceLowEmphasis
};